export const createImage = url =>
	new Promise((resolve, reject) => {
		const image = new Image();
		image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues
		image.src = url;
		image.addEventListener("load", () => resolve(image));
		image.addEventListener("error", () => {
			reject(new Error(`Error loading image from URL: ${url}`));
		});
	});

export const getCroppedImg = async (imageSrc, pixelCrop, bgColor = "transparent") => {
	try {
		const image = await createImage(imageSrc);

		const canvas = document.createElement("canvas");
		const ctx = canvas.getContext("2d");

		canvas.width = pixelCrop.width;
		canvas.height = pixelCrop.height;

		ctx.fillStyle = bgColor;
		ctx.fillRect(0, 0, canvas.width, canvas.height);

		ctx.drawImage(
			image,
			pixelCrop.x,
			pixelCrop.y,
			pixelCrop.width,
			pixelCrop.height,
			0,
			0,
			pixelCrop.width,
			pixelCrop.height
		);

		return new Promise((resolve, reject) => {
			const imageDataUrl = canvas.toDataURL("image/png");
			const file = dataURLtoBlob(imageDataUrl);
			if (!file) {
				reject(new Error("Canvas is empty"));
				return;
			}
			file.name = `${new Date().getTime()}.png`;
			resolve(file);
			//canvas.toBlob(file => {}, "image/png", 1);
		});
	} catch (error) {
		console.error("Error in getCroppedImg:", error);
		throw error;
	}
};

export const readFile = file => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.addEventListener("load", () => resolve(reader.result), false);
		reader.addEventListener("error", error => reject(error));
		reader.readAsDataURL(file);
	});
};

const dataURLtoBlob = dataurl => {
	var arr = dataurl.split(","),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n);
	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}
	return new Blob([u8arr], { type: mime });
};
